export interface PhoenixDeployment {
    DeploymentId: number;
	CustomerIdentifier: string;
    Name: string;
    DatabaseName: string;
    DatabaseRootPath: string;
    DatabaseServer: string;
    DeploymentGroupName: string;
    DiskgroupRootPath: string;
    DeploymentStatus: number;
    Links: PhoenixDeploymentLinkGroup;
    SystemName: string;
}

export interface PhoenixDeploymentLinkGroup {
    Deployment: string;
    ApiPath: string;
    GetUserGroups: string;
    CreateUserGroup: string;
}

export interface DeploymentGroup {
	DeploymentGroupId:number;
	GroupName:string;
}

export function isDeployment(obj:any): obj is PhoenixDeployment{
    return angular.isDefined(obj) && 
        angular.isDefined(obj.DeploymentId) && 
        angular.isDefined(obj.SystemName);
}


// WEBPACK FOOTER //
// ./src/phoenix/domain/phoenix-deployment.ts